import { NotFound } from '@/features/common'
/**
 * 创建模块路由
 * @returns
 */
export const createModuleRoutes = () => {
  const files = (require as any).context('./', false, /\.tsx$/)
  const moduleRoutes = []
  files.keys().forEach((key: string) => {
    const item = files(key)
    moduleRoutes.push(...item.default)
  })

  // 404页面，放到最后
  moduleRoutes.push({ path: '*', Component: NotFound })

  return moduleRoutes
}
